// 客服图标组件
const CustomerServiceIcon = ({ isActive, className = "nav-icon" }) => {
  const iconColor = isActive ? '#6366f1' : '#9ca3af';
  
  return (
    <svg 
      width="24" 
      height="24" 
      viewBox="0 0 24 24" 
      fill="none" 
      className={className}
      style={{ width: '24px', height: '24px' }}
    >
      {/* 头像圆圈 */}
      <circle 
        cx="12" 
        cy="8" 
        r="3" 
        stroke={iconColor} 
        strokeWidth="2" 
        fill={isActive ? '#e0e7ff' : 'none'}
      />
      
      {/* 身体/对话框 */}
      <path 
        d="M6 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2" 
        stroke={iconColor} 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
        fill="none"
      />
      
      {/* 客服耳机 */}
      <path 
        d="M8 8h-1a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h1" 
        stroke={iconColor} 
        strokeWidth="1.5" 
        strokeLinecap="round" 
        fill="none"
      />
      <path 
        d="M16 8h1a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-1" 
        stroke={iconColor} 
        strokeWidth="1.5" 
        strokeLinecap="round" 
        fill="none"
      />
      
      {/* 麦克风 */}
      <circle 
        cx="12" 
        cy="12" 
        r="1" 
        fill={iconColor}
      />
      <path 
        d="M12 13v2" 
        stroke={iconColor} 
        strokeWidth="1.5" 
        strokeLinecap="round"
      />
    </svg>
  );
};

export default CustomerServiceIcon;
